import React from "react";
import { Box } from "@mui/material";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import { Outlet } from "react-router-dom";
import ChatButtonAndPopup from "../Admin/ChatButtonAndPopup";

function AdminLayout() {
  const sidebarWidth = 240;

  return (
    <Box sx={{ display: "flex", height: "100vh", background: "#f5f7fb", overflow: "hidden" }}>
      
      {/* Sidebar */}
      <Box
        sx={{
          width: sidebarWidth,
          flexShrink: 0,
          height: "100vh",
          bgcolor: "#111827", // dark modern sidebar
          color: "#fff",
          overflowY: "auto",
        }}
      >
        <Sidebar />
      </Box>

      {/* Main Content */}
      <Box
        sx={{
          flexGrow: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        
        {/* Navbar */}
        <Box
          sx={{
            height: "64px",
            bgcolor: "#ffffff",
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            alignItems: "center",
            px: 0,
            position: "sticky",
            top: 0,
            zIndex: 1000,
          }}
        >
          <Navbar />
        </Box>

        {/* Page Content */}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            p: 3,
          }}
        >
          <Outlet />
        </Box>
      </Box>
      <ChatButtonAndPopup />
    </Box>
  );
}

export default AdminLayout;
